import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
	Avatar,
	Breadcrumb,
	Button,
	Col,
	Form,
	Input,
	Layout,
	List,
	Modal,
	message,
	Radio,
	Row,
	Select,
	Spin,
	Tag,
	Typography,
} from "antd";
import React from "react";
import { IoAddCircleOutline, IoCheckmarkDone, IoClose } from "react-icons/io5";
import ReactInputMask from "react-input-mask";
import { Link, Navigate } from "react-router-dom";
import {
	BLOCK_FORM_ENTER,
	getToken,
	POST_API,
	POST_CATCH,
	titleWeb,
	verifyConfig,
} from "../../../services/api";
// CONTROLLER
import Page403 from "../../Controller/Page403";
import PageLoad from "../../Controller/PageLoad";

class AdminProcessForm extends React.Component {
	state = {
		_plan: false,
		_navigate: false,
		_navigate_duplicate: false,
		_duplicate_id: 0,
		_loading: false,
		_screen: true,
		tag_value: "",
		_params: window.location.href.split("/"),
		defaultValue: null,
		_filters: {
			STATE: [],
			CITY: [],
			PROCESS_STEP: [],
			PROCESS_COURT: [],
			PROCESS_STATUS: [],
			PROCESS_ACTION: [],
			PROCESS_INSTANCE: [],
			PROCESS_CHANCE_WIN: [],
		},
		process_step_other: false,
		process_status_other: false,
		process_court_other: false,
		process_action_other: false,
		process_instance_other: false,
		process_chance_win_other: false,
		// RENDERS
		client_loading: false,
		client_data: [],
		client_set: [],
		lawyer_loading: false,
		lawyer_data: [],
		lawyer_set: [],
		tag_loading: false,
		tag_data: [],
		tag_set: [],
		opposing_part_loading: false,
		opposing_part_data: [],
		opposing_part_set: [],
	};

	back = "/painel/processos";

	routes = [
		{ title: <Link to={this.back}>Processos</Link> },
		{ title: this.props.type === "add" ? "Adicionar" : "Editar" },
	];

	componentDidMount = () => {
		titleWeb("Processos");
		this.onFilter().then(() => {
			if (this.props.type === "add") {
				this.setState({ _screen: false });
			} else if (this.props.type === "edit") {
				this.onView();
			}
		});
	};

	onAdd = () => {
		var self = this;
		Modal.confirm({
			title: "Adicionar nova tag?",
			icon: <ExclamationCircleOutlined />,
			cancelText: "Não",
			okText: "Sim",
			onOk() {
				POST_API("/tag/save.php", {
					token: getToken(),
					master: JSON.stringify({ NAME: self.state.tag_value, TYPE: "P" }),
				})
					.then((rs) => rs.json())
					.then((res) => {
						if (res.return) {
							message.success({ content: res.msg, key: "screen" });
							self.onSelectTag(res.new);
						} else {
							message.warning({ content: res.msg, key: "screen" });
						}
					})
					.catch(() => {
						POST_CATCH();
					})
					.finally(() => self.setState({ _loading: false, _modal: false }));
			},
			onCancel() {},
		});
	};

	onView = async () => {
		POST_API("/process/search.php", {
			token: getToken(),
			type: "view",
			filter: JSON.stringify({ ID: this.state._params[5] }),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({
						_plan: res.option,
						defaultValue: res.data,
						client_set: res.data.CLIENTS,
						lawyer_set: res.data.LAWYERS,
						opposing_part_set: res.data.OPPOSING_PARTS,
						tag_set: res.data.TAGS,
					});
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ _screen: false }));
	};

	onFilter = async () => {
		POST_API("/process/filters.php", { token: getToken() })
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({
						_filters: {
							CITY: res.data.CITY,
							STATE: res.data.STATE,
							PROCESS_STEP: res.data.PROCESS_STEP,
							PROCESS_COURT: res.data.PROCESS_COURT,
							PROCESS_STATUS: res.data.PROCESS_STATUS,
							PROCESS_ACTION: res.data.PROCESS_ACTION,
							PROCESS_INSTANCE: res.data.PROCESS_INSTANCE,
							PROCESS_CHANCE_WIN: res.data.PROCESS_CHANCE_WIN,
						},
					});
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH());
	};

	onSend = (values) => {
		this.setState({ _loading: true });
		values.LAWYER = this.state.lawyer_set;
		values.CLIENT = this.state.client_set;
		values.OPPOSING_PART = this.state.opposing_part_set;
		values.TAG = this.state.tag_set;
		POST_API("/process/save.php", {
			token: getToken(),
			type: this.props.type,
			master: JSON.stringify(values),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
					this.setState({ _navigate: true });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ _loading: false }));
	};

	onChangeProcessStep = (v) => {
		if (v === "*") this.setState({ process_step_other: true });
		if (v !== "*") this.setState({ process_step_other: false });
	};
	onChangeProcessStatus = (v) => {
		if (v === "*") this.setState({ process_status_other: true });
		if (v !== "*") this.setState({ process_status_other: false });
	};
	onChangeProcessAction = (v) => {
		if (v === "*") this.setState({ process_action_other: true });
		if (v !== "*") this.setState({ process_action_other: false });
	};
	onChangeProcessCourt = (v) => {
		if (v === "*") this.setState({ process_court_other: true });
		if (v !== "*") this.setState({ process_court_other: false });
	};
	onChangeProcessInstance = (v) => {
		if (v === "*") this.setState({ process_instance_other: true });
		if (v !== "*") this.setState({ process_instance_other: false });
	};
	onChangeProcessChanceWin = (v) => {
		if (v === "*") this.setState({ process_chance_win_other: true });
		if (v !== "*") this.setState({ process_chance_win_other: false });
	};

	onSearchClient = (v) => {
		this.setState({ client_loading: true });
		POST_API("/client/search.php", {
			token: getToken(),
			pagination: JSON.stringify({ current: 1, total: 0, limit: 10 }),
			search: v,
			type: "list",
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({
						client_data: res.data,
					});
				} else {
					message.error({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ client_loading: false }));
	};
	onSelectClient = (v) => {
		var verify = true;
		this.state.client_set.map((i) => {
			if (i.ID === v.ID) verify = false;
			return null;
		});

		if (verify) {
			this.setState({
				client_data: [],
				client_set: [...this.state.client_set, v],
			});
		} else {
			this.setState({ client_data: [] });
		}
	};
	onDiselectClient = (i) => {
		var temp = this.state.client_set;
		temp.shift(i, 1);
		this.setState({ client_set: temp });
	};

	onSearchLawyer = (v) => {
		this.setState({ lawyer_loading: true });
		POST_API("/lawyer/search.php", {
			token: getToken(),
			pagination: JSON.stringify({ current: 1, total: 0, limit: 10 }),
			search: v,
			type: "list",
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({
						lawyer_data: res.data,
					});
				} else {
					message.error({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ lawyer_loading: false }));
	};
	onSelectLawyer = (v) => {
		var verify = true;
		this.state.lawyer_set.map((i) => {
			if (i.ID === v.ID) verify = false;
			return null;
		});

		if (verify) {
			this.setState({
				lawyer_data: [],
				lawyer_set: [...this.state.lawyer_set, v],
			});
		} else {
			this.setState({ lawyer_data: [] });
		}
	};
	onDiselectLawyer = (i) => {
		var temp = this.state.lawyer_set;
		temp.shift(i, 1);
		this.setState({ lawyer_set: temp });
	};

	onSearchTag = (v) => {
		this.setState({ tag_loading: true });
		POST_API("/tag/search.php", {
			token: getToken(),
			pagination: JSON.stringify({ current: 1, total: 0, limit: 10 }),
			filter: JSON.stringify({ TYPE: "P" }),
			search: v,
			type: "list",
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({
						tag_data: res.data,
					});
				} else {
					message.error({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ tag_loading: false }));
	};
	onSelectTag = (v) => {
		var verify = true;
		this.state.tag_set.map((i) => {
			if (i.ID === v.ID) verify = false;
			return null;
		});

		if (verify) {
			this.setState({
				tag_data: [],
				tag_set: [...this.state.tag_set, v],
			});
		} else {
			this.setState({ tag_data: [] });
		}
	};
	onDiselectTag = (i) => {
		var temp = this.state.tag_set;
		temp.shift(i, 1);
		this.setState({ tag_set: temp });
	};

	onSearchOpposingPart = (v) => {
		this.setState({ opposing_part_loading: true });
		POST_API("/opposing_part/search.php", {
			token: getToken(),
			pagination: JSON.stringify({ current: 1, total: 0, limit: 10 }),
			filter: JSON.stringify({ TYPE: "P" }),
			search: v,
			type: "list",
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({
						opposing_part_data: res.data,
					});
				} else {
					message.error({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ opposing_part_loading: false }));
	};
	onSelectOpposingPart = (v) => {
		var verify = true;
		this.state.opposing_part_set.map((i) => {
			if (i.ID === v.ID) verify = false;
			return null;
		});

		if (verify) {
			this.setState({
				opposing_part_data: [],
				opposing_part_set: [...this.state.opposing_part_set, v],
			});
		} else {
			this.setState({ opposing_part_data: [] });
		}
	};
	onDiselectOpposingPart = (i) => {
		var temp = this.state.opposing_part_set;
		temp.shift(i, 1);
		this.setState({ opposing_part_set: temp });
	};

	changeDuplicate = async (value) => {
		this.setState({ _duplicate_id: value });
	};

	onDuplicate = () => {
		var self = this;
		Modal.confirm({
			title: "Deseja duplicar o processo?",
			icon: <ExclamationCircleOutlined />,
			cancelText: "Não",
			okText: "Sim",
			onOk() {
				POST_API("/process/duplicate.php", {
					token: getToken(),
					ID: self.state.defaultValue.ID,
				})
					.then((rs) => rs.json())
					.then(async (res) => {
						if (res.return) {
							message.success({ content: res.msg, key: "screen" });
							await self.changeDuplicate(res.id).then(() => {
								self.setState({ _navigate_duplicate: true });
							});
						} else {
							message.warning({ content: res.msg, key: "screen" });
						}
					})
					.catch(() => {
						POST_CATCH();
					})
					.finally(() => self.setState({ _loading: false }));
			},
			onCancel() {},
		});
	};

	onChangeState = async (v) => {
		POST_API("/process/filters-city.php", { token: getToken(), STATE_ID: v })
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({
						_filters: {
							...this.state._filters,
							CITY: res.data.CITY,
						},
					});
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH());
	};

	render = () => {
		if (this.state._navigate) return <Navigate to={this.back} />;
		if (!verifyConfig(`${this.props.per}.${this.props.type}`))
			return <Page403 />;

		if (this.state._navigate_duplicate) {
			return <Navigate to={this.back} />;
		}

		return (
			<Layout>
				<Layout.Content className={"admin-container"}>
					<Row align={"middle"} gutter={[8, 8]}>
						<Col span={18}>
							<Breadcrumb items={this.routes} />
						</Col>
						<Col
							span={6}
							style={{ display: "flex", justifyContent: "flex-end" }}
						>
							<Link to={this.back}>
								<Button
									className="sys-btn-primary sys-btn-small"
									shape="round"
									size="small"
									type="primary"
								>
									Voltar
								</Button>
							</Link>
						</Col>
						{this.state._screen ? (
							<PageLoad />
						) : (
							<Col span={24}>
								<Form
									className={"admin-form"}
									initialValues={this.state.defaultValue}
									layout="vertical"
									onFinish={this.onSend}
									onKeyDown={BLOCK_FORM_ENTER}
								>
									<Row align={"bottom"} gutter={[16, 0]}>
										<Col md={7} xs={10}>
											<Form.Item label="ID do Processo" name="ID">
												<Input disabled />
											</Form.Item>
										</Col>
										<Col md={7} xs={14}>
											<Form.Item label="Data do Ajuizamento" name="DATE_FILING">
												<Input type="date" />
											</Form.Item>
										</Col>
										<Col md={10} xs={24}>
											<Form.Item
												label="Número Processo"
												name="NUMBER"
												rules={[
													{ required: true, message: "Campo obrigatório" },
												]}
											>
												<ReactInputMask
													className="ant-input css-dev-only-do-not-override-w8mnev css-w8mnev"
													mask={"9999999-99.9999.9.99.9999"}
													maskChar={""}
													maxLength={25}
												>
													{(props) => <Input {...props} />}
												</ReactInputMask>
											</Form.Item>
										</Col>
										<Col
											md={this.state.process_step_other ? 4 : 14}
											xs={this.state.process_step_other ? 10 : 24}
										>
											<Form.Item label="Situação" name="PROCESS_STEP_ID">
												<Select
													allowClear
													onChange={this.onChangeProcessStep}
													placeholder="Selecione..."
												>
													{this.state._filters.PROCESS_STEP.map((v, i) => (
														<Select.Option key={i} value={v.ID}>
															{v.NAME}
														</Select.Option>
													))}
													<Select.Option value="*">Outro</Select.Option>
												</Select>
											</Form.Item>
										</Col>
										{this.state.process_step_other ? (
											<Col md={10} xs={14}>
												<Form.Item name="PROCESS_STEP_OTHER">
													<Input placeholder="Digite aqui" />
												</Form.Item>
											</Col>
										) : null}
										<Col
											md={this.state.process_status_other ? 4 : 10}
											xs={this.state.process_status_other ? 10 : 24}
										>
											<Form.Item label="Status" name="PROCESS_STATUS_ID">
												<Select
													allowClear
													onChange={this.onChangeProcessStatus}
													placeholder="Selecione..."
												>
													{this.state._filters.PROCESS_STATUS.map((v, i) => (
														<Select.Option key={i} value={v.ID}>
															{v.NAME}
														</Select.Option>
													))}
													<Select.Option value="*">Outro</Select.Option>
												</Select>
											</Form.Item>
										</Col>
										{this.state.process_status_other ? (
											<Col md={6} xs={14}>
												<Form.Item name="PROCESS_STATUS_OTHER">
													<Input placeholder="Digite aqui" />
												</Form.Item>
											</Col>
										) : null}
										<Col md={24} xs={24}>
											<Form.Item label="Título" name="TITLE">
												<Input />
											</Form.Item>
										</Col>
										<Col md={24} xs={24}>
											<Form.Item label="Clientes">
												<Input.Search
													onSearch={this.onSearchClient}
													placeholder="Procurar cliente..."
												/>
												{this.state.client_loading ? (
													<center>
														<Spin style={{ marginTop: 10 }} />
													</center>
												) : (
													<>
														{this.state.client_data.length > 0 ? (
															<List
																dataSource={this.state.client_data}
																itemLayout="horizontal"
																renderItem={(item, index) => (
																	<List.Item
																		actions={[
																			<Button
																				className="table__btn_recover"
																				onClick={() =>
																					this.onSelectClient(item)
																				}
																				shape="circle"
																				title="Marcar"
																				type="primary"
																			>
																				<IoCheckmarkDone size={22} />
																			</Button>,
																		]}
																		key={index}
																	>
																		<List.Item.Meta
																			avatar={<Avatar src={item.AVATAR} />}
																			description={item.LOGIN}
																			title={
																				<Typography>{item.NAME}</Typography>
																			}
																		/>
																	</List.Item>
																)}
															/>
														) : null}
													</>
												)}
												{this.state.client_set.length > 0 ? (
													<List
														dataSource={this.state.client_set}
														itemLayout="horizontal"
														renderItem={(item, index) => (
															<List.Item
																actions={[
																	<Button
																		className="table__btn_delete"
																		onClick={() => this.onDiselectClient(index)}
																		shape="circle"
																		title="Desmarcar"
																		type="primary"
																	>
																		<IoClose size={22} />
																	</Button>,
																]}
																key={index}
															>
																<List.Item.Meta
																	avatar={<Avatar src={item.AVATAR} />}
																	description={item.LOGIN}
																	title={<Typography>{item.NAME}</Typography>}
																/>
															</List.Item>
														)}
													/>
												) : null}
											</Form.Item>
										</Col>
										<Col md={24} xs={24}>
											<Form.Item label="Partes Contrária">
												<Input.Search
													onSearch={this.onSearchOpposingPart}
													placeholder="Procurar parte contrária..."
												/>
												{this.state.opposing_part_loading ? (
													<center>
														<Spin style={{ marginTop: 10 }} />
													</center>
												) : (
													<>
														{this.state.opposing_part_data.length > 0 ? (
															<List
																dataSource={this.state.opposing_part_data}
																itemLayout="horizontal"
																renderItem={(item, index) => (
																	<List.Item
																		actions={[
																			<Button
																				className="table__btn_recover"
																				onClick={() =>
																					this.onSelectOpposingPart(item)
																				}
																				shape="circle"
																				title="Marcar"
																				type="primary"
																			>
																				<IoCheckmarkDone size={22} />
																			</Button>,
																		]}
																		key={index}
																	>
																		<List.Item.Meta
																			avatar={<Avatar src={item.AVATAR} />}
																			description={item.LOGIN}
																			title={
																				<Typography>{item.NAME}</Typography>
																			}
																		/>
																	</List.Item>
																)}
															/>
														) : null}
													</>
												)}
												{this.state.opposing_part_set.length > 0 ? (
													<List
														dataSource={this.state.opposing_part_set}
														itemLayout="horizontal"
														renderItem={(item, index) => (
															<List.Item
																actions={[
																	<Button
																		className="table__btn_delete"
																		onClick={() =>
																			this.onDiselectOpposingPart(index)
																		}
																		shape="circle"
																		title="Desmarcar"
																		type="primary"
																	>
																		<IoClose size={22} />
																	</Button>,
																]}
																key={index}
															>
																<List.Item.Meta
																	avatar={<Avatar src={item.AVATAR} />}
																	description={item.LOGIN}
																	title={<Typography>{item.NAME}</Typography>}
																/>
															</List.Item>
														)}
													/>
												) : null}
											</Form.Item>
										</Col>
										<Col
											md={this.state.process_action_other ? 4 : 14}
											xs={this.state.process_action_other ? 10 : 24}
										>
											<Form.Item label="Tipo de Ação" name="PROCESS_ACTION_ID">
												<Select
													allowClear
													onChange={this.onChangeProcessAction}
													placeholder="Selecione..."
												>
													{this.state._filters.PROCESS_ACTION.map((v, i) => (
														<Select.Option key={i} value={v.ID}>
															{v.NAME}
														</Select.Option>
													))}
													<Select.Option value="*">Outro</Select.Option>
												</Select>
											</Form.Item>
										</Col>
										{this.state.process_action_other ? (
											<Col md={10} xs={14}>
												<Form.Item name="PROCESS_ACTION_OTHER">
													<Input placeholder="Digite aqui" />
												</Form.Item>
											</Col>
										) : null}
										<Col
											md={this.state.process_court_other ? 4 : 10}
											xs={this.state.process_court_other ? 10 : 24}
										>
											<Form.Item label="Tribunal" name="PROCESS_COURT_ID">
												<Select
													allowClear
													onChange={this.onChangeProcessCourt}
													placeholder="Selecione..."
												>
													{this.state._filters.PROCESS_COURT.map((v, i) => (
														<Select.Option key={i} value={v.ID}>
															{v.NAME}
														</Select.Option>
													))}
													<Select.Option value="*">Outro</Select.Option>
												</Select>
											</Form.Item>
										</Col>
										{this.state.process_court_other ? (
											<Col md={6} xs={14}>
												<Form.Item name="PROCESS_COURT_OTHER">
													<Input placeholder="Digite aqui" />
												</Form.Item>
											</Col>
										) : null}
										<Col md={4} xs={8}>
											<Form.Item label="UF" name="STATE">
												<Select
													onChange={this.onChangeState}
													onSearch={this.onSearch}
												>
													{this.state._filters.STATE.map((v, i) => (
														<Select.Option key={i} value={v.ID}>
															{v.STATE}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
										<Col md={12} xs={16}>
											<Form.Item label="Cidade" name="CITY">
												<Select>
													{this.state._filters.CITY.map((v, i) => (
														<Select.Option key={i} value={v.ID}>
															{v.NAME}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
										<Col
											md={this.state.process_instance_other ? 3 : 8}
											xs={this.state.process_instance_other ? 10 : 24}
										>
											<Form.Item label="Instância" name="PROCESS_INSTANCE_ID">
												<Select
													allowClear
													onChange={this.onChangeProcessInstance}
													placeholder="Selecione..."
												>
													{this.state._filters.PROCESS_INSTANCE.map((v, i) => (
														<Select.Option key={i} value={v.ID}>
															{v.NAME}
														</Select.Option>
													))}
													<Select.Option value="*">Outro</Select.Option>
												</Select>
											</Form.Item>
										</Col>
										{this.state.process_instance_other ? (
											<Col md={5} xs={14}>
												<Form.Item name="PROCESS_INSTANCE_OTHER">
													<Input placeholder="Digite aqui" />
												</Form.Item>
											</Col>
										) : null}
										<Col md={24} xs={24}>
											<Form.Item label="Foro | Juízo" name="LOCAL">
												<Input />
											</Form.Item>
										</Col>
										<Col md={24} xs={24}>
											<Form.Item label="Magistrado" name="MAGISTRATE">
												<Input />
											</Form.Item>
										</Col>
										<Col md={24} xs={24}>
											<Form.Item label="Resumo do Processo" name="DETAILS">
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
										<Col md={6} xs={12}>
											<Form.Item label="Justiça Gratuita" name="DEMAND">
												<Radio.Group>
													<Radio value={"S"}>Sim</Radio>
													<Radio value={"N"}>Não</Radio>
												</Radio.Group>
											</Form.Item>
										</Col>
										<Col md={8} xs={12}>
											<Form.Item label="Valor da Causa" name="VALUE">
												<Input prefix="R$" type="number" />
											</Form.Item>
										</Col>
										<Col
											md={this.state.process_chance_win_other ? 4 : 10}
											xs={this.state.process_chance_win_other ? 10 : 24}
										>
											<Form.Item
												label="Chance Ganho"
												name="PROCESS_CHANCE_WIN_ID"
											>
												<Select
													allowClear
													onChange={this.onChangeProcessChanceWin}
													placeholder="Selecione..."
												>
													{this.state._filters.PROCESS_CHANCE_WIN.map(
														(v, i) => (
															<Select.Option key={i} value={v.ID}>
																{v.NAME}
															</Select.Option>
														),
													)}
													<Select.Option value="*">Outro</Select.Option>
												</Select>
											</Form.Item>
										</Col>
										{this.state.process_chance_win_other ? (
											<Col md={6} xs={14}>
												<Form.Item name="PROCESS_CHANCE_WIN_OTHER">
													<Input placeholder="Digite aqui" />
												</Form.Item>
											</Col>
										) : null}
										<Col md={24} xs={24}>
											<Form.Item label="Advogados">
												<Input.Search
													onSearch={this.onSearchLawyer}
													placeholder="Procurar advogado..."
												/>
												{this.state.lawyer_loading ? (
													<center>
														<Spin style={{ marginTop: 10 }} />
													</center>
												) : (
													<>
														{this.state.lawyer_data.length > 0 ? (
															<List
																dataSource={this.state.lawyer_data}
																itemLayout="horizontal"
																renderItem={(item, index) => (
																	<List.Item
																		actions={[
																			<Button
																				className="table__btn_recover"
																				onClick={() =>
																					this.onSelectLawyer(item)
																				}
																				shape="circle"
																				title="Marcar"
																				type="primary"
																			>
																				<IoCheckmarkDone size={22} />
																			</Button>,
																		]}
																		key={index}
																	>
																		<List.Item.Meta
																			avatar={<Avatar src={item.AVATAR} />}
																			description={item.LOGIN}
																			title={
																				<Typography>{item.NAME}</Typography>
																			}
																		/>
																	</List.Item>
																)}
															/>
														) : null}
													</>
												)}
												{this.state.lawyer_set.length > 0 ? (
													<List
														dataSource={this.state.lawyer_set}
														itemLayout="horizontal"
														renderItem={(item, index) => (
															<List.Item
																actions={[
																	<Button
																		className="table__btn_delete"
																		onClick={() => this.onDiselectLawyer(index)}
																		shape="circle"
																		title="Desmarcar"
																		type="primary"
																	>
																		<IoClose size={22} />
																	</Button>,
																]}
																key={index}
															>
																<List.Item.Meta
																	avatar={<Avatar src={item.AVATAR} />}
																	description={item.LOGIN}
																	title={<Typography>{item.NAME}</Typography>}
																/>
															</List.Item>
														)}
													/>
												) : null}
											</Form.Item>
										</Col>
										<Col md={24} xs={24}>
											<Form.Item label="Tags">
												<Input.Search
													onChange={(v) =>
														this.setState({ tag_value: v.target.value })
													}
													onSearch={this.onSearchTag}
													placeholder="Procurar tag..."
													suffix={
														<IoAddCircleOutline
															onClick={this.onAdd}
															size={20}
															style={{ cursor: "pointer" }}
														/>
													}
												/>
												{this.state.tag_loading ? (
													<center>
														<Spin style={{ marginTop: 10 }} />
													</center>
												) : (
													<>
														{this.state.tag_data.length > 0 ? (
															<List
																dataSource={this.state.tag_data}
																itemLayout="horizontal"
																renderItem={(item, index) => (
																	<List.Item
																		actions={[
																			<Button
																				className="table__btn_recover"
																				onClick={() => this.onSelectTag(item)}
																				shape="circle"
																				title="Marcar"
																				type="primary"
																			>
																				<IoCheckmarkDone size={22} />
																			</Button>,
																		]}
																		key={index}
																	>
																		<List.Item.Meta
																			title={
																				<Tag color={item.COLOR}>
																					{item.NAME}
																				</Tag>
																			}
																		/>
																	</List.Item>
																)}
															/>
														) : null}
													</>
												)}
												{this.state.tag_set.length > 0 ? (
													<List
														dataSource={this.state.tag_set}
														itemLayout="horizontal"
														renderItem={(item, index) => (
															<List.Item
																actions={[
																	<Button
																		className="table__btn_delete"
																		onClick={() => this.onDiselectTag(index)}
																		shape="circle"
																		title="Desmarcar"
																		type="primary"
																	>
																		<IoClose size={22} />
																	</Button>,
																]}
																key={index}
															>
																<List.Item.Meta
																	title={
																		<Tag color={item.COLOR}>{item.NAME}</Tag>
																	}
																/>
															</List.Item>
														)}
													/>
												) : null}
											</Form.Item>
										</Col>
										<Col md={24} xs={24}>
											{this.props.type === "edit" && this.state._plan ? (
												<Button
													className="float-left"
													loading={this.state._loading}
													onClick={this.onDuplicate}
													shape="round"
													type="default"
												>
													Duplicar
												</Button>
											) : null}
											<Button
												className="float-right"
												htmlType="submit"
												loading={this.state._loading}
												shape="round"
												type="primary"
											>
												Salvar
											</Button>
										</Col>
									</Row>
								</Form>
							</Col>
						)}
					</Row>
				</Layout.Content>
			</Layout>
		);
	};
}

export default AdminProcessForm;
